import { useMutation } from 'react-query'
import putRegisterResponsible from '../services/putRegisterResponsible'

function usePutRegisterResponsible() {

  return useMutation((value:object)=>putRegisterResponsible(value) );
}

export default usePutRegisterResponsible
